"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANGE_ROUTE = 'CHANGE_ROUTE';
exports.CLEAR_ROUTE = 'CLEAR_ROUTE';
exports.TRANSITION_FADE_OUT = 'TRANSITION_FADE_OUT';
exports.TRANSITION_FADE_IN = 'TRANSITION_FADE_IN';
exports.DefaultRoute = {
    enter: {
        overpanel: false,
        view: '',
        slide: 0,
        params: null,
        query: null
    },
    exit: null,
    isFlow: false,
    transition: ''
};
function changeRoute(route) {
    if (route === void 0) { route = exports.DefaultRoute; }
    return {
        type: [exports.CHANGE_ROUTE],
        route: route
    };
}
exports.default = changeRoute;
function clearRoute(route) {
    if (route === void 0) { route = exports.DefaultRoute; }
    return {
        type: [exports.CLEAR_ROUTE],
        route: {
            enter: {},
            exit: {}
        }
    };
}
exports.clearRoute = clearRoute;
function transitionIn() {
    return {
        type: [exports.TRANSITION_FADE_IN]
    };
}
exports.transitionIn = transitionIn;
function transitionOut() {
    return {
        type: [exports.TRANSITION_FADE_OUT]
    };
}
exports.transitionOut = transitionOut;
